// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n:root {\n\t--slider-connect-bg: #7d8bf7;\n\t--slider-height: 3px;\n\t--slider-bg: #e2e3ee;\n\t--slider-handle-bg: #7d8bf7;\n\t--slider-handle-shadow: none;\n\t--slider-handle-shadow-active: 0.5px 0.5px 2px 1px rgba(0, 0, 0, 0.22);\n\t--slider-handle-width: 24px;\n\t--slider-handle-height: 24px;\n}\n", ""]);
// Exports
module.exports = exports;
